var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _g, _path16, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoInfiniteLaunch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 32,
    viewBox: "0 0 162 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1435 20.4054H25.4049V6.22156H22.1435V20.4054Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2155 10.5779C26.2155 9.97095 26.33 9.40377 26.5593 8.8763C26.7893 8.35016 27.0991 7.89024 27.4915 7.49938C27.8832 7.10699 28.3425 6.79691 28.8691 6.56606C29.3961 6.33698 29.9633 6.22156 30.5709 6.22156H32.7597C33.3673 6.22156 33.9347 6.33698 34.4615 6.56606C34.9883 6.79691 35.4476 7.10699 35.8391 7.49938C36.2308 7.89024 36.5416 8.35016 36.7715 8.8763C37.0008 9.40377 37.1154 9.97095 37.1154 10.5779V20.4052H33.8537V10.5779C33.8537 10.281 33.7493 10.0255 33.5399 9.80786C33.3302 9.5918 33.07 9.48454 32.7597 9.48454H30.5709C30.2601 9.48454 30.0004 9.5918 29.7909 9.80786C29.5815 10.0255 29.4769 10.281 29.4769 10.5779V20.4052H26.2155V10.5779Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.5023 9.81933C41.2929 10.0288 41.1883 10.281 41.1883 10.5779V11.6727H48.8267V14.9556H41.1883V20.4052H37.9268V10.5779C37.9268 9.97095 38.0411 9.40377 38.2704 8.8763C38.5004 8.35016 38.8105 7.89024 39.2029 7.49938C39.5944 7.10699 40.0539 6.79691 40.5805 6.56606C41.1075 6.33698 41.6747 6.22156 42.2822 6.22156H48.8267V9.5044H42.2822C41.9715 9.5044 41.7117 9.60989 41.5023 9.81933Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.6382 20.4054H52.8996V6.22156H49.6382V20.4054Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.71 10.5779C53.71 9.97095 53.8247 9.40377 54.0538 8.8763C54.2838 8.35016 54.5938 7.89024 54.9862 7.49938C55.378 7.10699 55.837 6.79691 56.3638 6.56606C56.8906 6.33698 57.4578 6.22156 58.0654 6.22156H60.2542C60.862 6.22156 61.4294 6.33698 61.956 6.56606C62.4828 6.79691 62.9421 7.10699 63.3336 7.49938C63.7253 7.89024 64.0361 8.35016 64.2663 8.8763C64.4953 9.40377 64.6101 9.97095 64.6101 10.5779V20.4052H61.3485V10.5779C61.3485 10.281 61.2438 10.0255 61.0344 9.80786C60.825 9.5918 60.5645 9.48454 60.2542 9.48454H58.0654C57.7546 9.48454 57.4949 9.5918 57.2854 9.80786C57.0762 10.0255 56.9714 10.281 56.9714 10.5779V20.4052H53.71V10.5779Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.4212 20.4054H68.6826V6.22156H65.4212V20.4054Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.3196 9.50452H76.0377V20.4053H72.7753V9.50452H69.4932V6.22168H79.3196V9.50452Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.7066 9.81933C83.4972 10.0288 83.3925 10.281 83.3925 10.5779V11.6727H91.031V14.9556H83.3925V16.0489C83.3925 16.3457 83.4972 16.6031 83.7066 16.8189C83.916 17.035 84.1758 17.1438 84.4865 17.1438H91.031V20.4052H84.4865C83.879 20.4052 83.3118 20.2898 82.7847 20.0607C82.2582 19.8316 81.7987 19.5213 81.4072 19.1289C81.0148 18.7368 80.7047 18.2784 80.4747 17.7505C80.2454 17.2245 80.1311 16.6574 80.1311 16.0489V10.5779C80.1311 9.97095 80.2454 9.40377 80.4747 8.8763C80.7047 8.35016 81.0148 7.89024 81.4072 7.49938C81.7987 7.10699 82.2582 6.79691 82.7847 6.56606C83.3118 6.33698 83.879 6.22156 84.4865 6.22156H91.031V9.5044H84.4865C84.1758 9.5044 83.916 9.60989 83.7066 9.81933Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.553 17.1438V20.4052H100.27C99.6622 20.4052 99.095 20.2898 98.5682 20.0607C98.0412 19.8316 97.5822 19.5213 97.1906 19.1289C96.7983 18.7368 96.488 18.2784 96.258 17.7505C96.0289 17.2245 95.9144 16.6574 95.9144 16.0489V6.22156H99.1966V16.0489C99.1966 16.3457 99.3009 16.6031 99.5106 16.8189C99.72 17.035 99.973 17.1438 100.27 17.1438H103.553Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.002 20.4053L109.813 12.2597L107.625 20.4053H104.363L108.152 6.22144H108.192H111.435H111.475L115.263 20.4053H112.002Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.164 16.0489C126.164 16.6574 126.049 17.2245 125.82 17.7505C125.59 18.2784 125.279 18.7368 124.888 19.1289C124.496 19.5213 124.037 19.8316 123.51 20.0607C122.983 20.2898 122.416 20.4052 121.809 20.4052H119.62C119.012 20.4052 118.445 20.2898 117.918 20.0607C117.391 19.8316 116.932 19.5213 116.54 19.1289C116.148 18.7368 115.838 18.2784 115.608 17.7505C115.379 17.2245 115.264 16.6574 115.264 16.0489V6.22156H118.526V16.0489C118.526 16.3457 118.63 16.6031 118.84 16.8189C119.049 17.035 119.309 17.1438 119.62 17.1438H121.809C122.119 17.1438 122.379 17.035 122.588 16.8189C122.798 16.6031 122.903 16.3457 122.903 16.0489V6.22156H126.164V16.0489Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.975 10.5779C126.975 9.97095 127.089 9.40377 127.318 8.8763C127.548 8.35016 127.858 7.89024 128.251 7.49938C128.642 7.10699 129.102 6.79691 129.628 6.56606C130.155 6.33698 130.722 6.22156 131.33 6.22156H133.519C134.127 6.22156 134.694 6.33698 135.221 6.56606C135.747 6.79691 136.207 7.10699 136.598 7.49938C136.99 7.89024 137.301 8.35016 137.531 8.8763C137.76 9.40377 137.875 9.97095 137.875 10.5779V20.4052H134.613V10.5779C134.613 10.281 134.508 10.0255 134.299 9.80786C134.09 9.5918 133.829 9.48454 133.519 9.48454H131.33C131.019 9.48454 130.76 9.5918 130.55 9.80786C130.341 10.0255 130.236 10.281 130.236 10.5779V20.4052H126.975V10.5779Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.01 16.819C146.22 16.6029 146.325 16.3456 146.325 16.049H149.586C149.586 16.6575 149.471 17.2246 149.242 17.7506C149.012 18.2782 148.701 18.7366 148.31 19.129C147.918 19.5214 147.459 19.8315 146.932 20.0606C146.405 20.2899 145.838 20.4053 145.23 20.4053H143.041C142.434 20.4053 141.867 20.2899 141.34 20.0606C140.813 19.8315 140.354 19.5214 139.962 19.129C139.57 18.7366 139.26 18.2782 139.03 17.7506C138.801 17.2246 138.686 16.6575 138.686 16.049V10.578C138.686 9.97105 138.801 9.40386 139.03 8.87618C139.26 8.35026 139.57 7.89011 139.962 7.49926C140.354 7.10709 140.813 6.79701 141.34 6.56616C141.867 6.33686 142.434 6.22144 143.041 6.22144H145.23C145.838 6.22144 146.405 6.33686 146.932 6.56616C147.459 6.79701 147.918 7.10709 148.31 7.49926C148.701 7.89011 149.012 8.35026 149.242 8.87618C149.471 9.40386 149.586 9.97105 149.586 10.578H146.325C146.325 10.2811 146.22 10.0289 146.01 9.81943C145.801 9.60999 145.54 9.5045 145.23 9.5045H143.041C142.731 9.5045 142.471 9.60999 142.261 9.81943C142.052 10.0289 141.947 10.2811 141.947 10.578V16.049C141.947 16.3456 142.052 16.6029 142.261 16.819C142.471 17.0351 142.731 17.1439 143.041 17.1439H145.23C145.54 17.1439 145.801 17.0351 146.01 16.819Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.296 6.22156V20.4054H158.035V14.9558H153.658V20.4054H150.396V6.22156H153.658V11.6727H158.035V6.22156H161.296Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_216:776",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 32
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H11.8414V32H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_216:776)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8414 32H9.46645C4.23839 32 -6.10352e-05 27.7617 -6.10352e-05 22.5334V0H11.8414V32Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_216:776",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 20,
    width: 13,
    height: 12
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8412 32H24.4714L12.8767 20.4052L12.8412 32Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_216:776)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 32H24L12.0367 20L12 32Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoInfiniteLaunch);
export default __webpack_public_path__ + "static/media/logo-infinite-launch.7b3e4a3e.svg";
export { ForwardRef as ReactComponent };